export default "/build/js/b04c70a13c5cfe979b06046ed14e4a45.css";